import React from 'react'

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

// Components
import {Button, routeTypes} from '@/components/ui/button'
import {Google} from 'hec/assets/icons'
import {useAppOrigin} from '~/app/hooks/use-app-origin'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const GoogleSignIn = () => {
    const config = getConfig()
    const {site} = useMultiSite()
    const siteId: string = site.id
    const appOrigin: string = useAppOrigin()
    const threeLetter: string = config.app.threeLetter

    const linkParams = {
        endpoint: 'Login-OAuthLogin',
        oauthProvider: 'Google' + threeLetter,
        target: '6',
        destination: window.location.href
    }

    const googleLoginLink = `${appOrigin}/on/demandware.store/Sites-${siteId}-Site/default/${linkParams.endpoint}?oauthProvider=${linkParams.oauthProvider}&oauthLoginTargetEndPoint=${linkParams.target}`

    return (
        <div className="flex flex-col w-[18.75rem] mx-auto">
            <Button
                ctaType="button"
                variant="normal"
                routeType={routeTypes.EXTERNAL}
                hrefValue={googleLoginLink}
                asChild
                openInNewTab={false}
                className="mb-1 pt-4 shadow-[0_0.0625rem_0.125rem_0_rgba(0,0,0,0.24)] font-grotesque text-[#757575] hover:text-[#212529] hover:bg-[#e2e6ea] hover:border-[#dae0e5] hover:no-underline w-full"
                data-testid="googleSignIn-Button"
            >
                <Google className="mb-1" />
                Sign in with Google
            </Button>
        </div>
    )
}

export default GoogleSignIn
